import { render } from "./PersonSelect.vue?vue&type=template&id=2109c4c7"
import script from "./PersonSelect.vue?vue&type=script&lang=js"
export * from "./PersonSelect.vue?vue&type=script&lang=js"

import "./PersonSelect.vue?vue&type=style&index=0&id=2109c4c7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__